module.exports = __webpack_public_path__ + "static/media/furia-interface.90851cb6.svg";